
// Widget Scripts
import swiperWidgetMainFeature from './js/widgets/swiperWidgetMainFeature';
import multiScheduleFeature from './js/widgets/multiScheduleFeature.js';
import cardWidgetButtons from './js/widgets/cardWidgetButtons.js';

import cardWidget from './js/widgets/cardWidget';
import cardWidgetTitles from './js/widgets/cardWidgetTitles';

import seoBlockFeature from './js/widgets/seoBlockFeature';

import { instafeed } from './js/widgets/socialNetworkWidget';
import videoWidgetSimple from './js/widgets/videoWidgetSimple';
import sponsors from './js/widgets/sponsors';



// Custom Theme Scripts
import './js/subPageThemes.js';
import './js/localjs.js';


// Initialize Homepage Widgets
if (window.location.pathname === '/') {

  $(document).ready(function () {

    swiperWidgetMainFeature()
    multiScheduleFeature()
    cardWidgetButtons()

    cardWidget();
    cardWidgetTitles();

    seoBlockFeature();
    instafeed(true);

  });

}
$(document).ready(function () {
  sponsors()
});




